import { Container, Grid } from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import FeedIcon from "@mui/icons-material/Feed";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import ExaminationsTable from "./components/ExaminationsTable";

import { getLanguage } from "../../../config/language/language.js";

export default function Examinations(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().ENTITIES_TITLE} subtitle={getLanguage().ENTITIES_SUBTITLE} icon={<FeedIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <ExaminationsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={1}
                    options={[
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        },
                        {
                            path: `/database/patients`,
                            title: "Patients",
                            variant: "outlined",
                            icon: <PermContactCalendarIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
